module.exports = __webpack_public_path__ + "img/collection_c.2511cfe5.png";